import Repository from "@/services/repository";

export default {
  createRemoveKeywords(studyId, keywordsTextAndLocationIds) {
    return Repository.post(`/a/${studyId}/keywords/bulk_destroy.json`, {
      keywordsTextAndLocationIds,
    }).then((response) => response.data);
  },
};
